'use strict';

import { createBus } from 'suber';

import { extractWidgetConfig } from '@/utils/config';
import { factory as instrumentsFactory } from '@/utils/instruments';
import ReactDispatcher from '@/app/dispatcher/react';
import WsGate from '@/api/wsgate';

let appConfig = {};
let wconfig = {};
let lang = null;
let symbols = [];
let widgets = [];
let meta = {};

const DEFAULT_LANG = 'en';
const bus = createBus();

function getWidgetsConfig (config) {
    let widgets = [];
    config['widgets'].forEach(widget => {
        const node = document.querySelector(widget['node']);
        const loadingNode = node && node.querySelector(widget['loadingNode']);

        widget['node'] = node;
        widget['loadingNode'] = loadingNode;
        widget['config']['width'] = parent.offsetWidth;
        widget['config']['height'] = parent.offsetHeight;
        widgets.push(widget);
    });
    return widgets;
}

function getAllInstrumentSymbols (widgetsConfig) {
    let symbols = [];
    (widgetsConfig || []).forEach(function (widget, index) {
        symbols = symbols.concat(widget['config']['symbols']);
    });
    return symbols.filter((v, i, a) => a.indexOf(v) === i);
}

export default class Application {
    constructor (config) {
        wconfig = extractWidgetConfig(config['globalScope'])['config'];
        appConfig = config;
    }

    bootstrap () {
        meta = wconfig['meta'] || {};
        lang = wconfig['lang'] || DEFAULT_LANG;
        widgets = getWidgetsConfig(wconfig);
        symbols = getAllInstrumentSymbols(widgets);
        return this;
    }

    run () {
        let self = this;
        instrumentsFactory(lang, symbols).then(instruments => {
            widgets.forEach(w => {
                let { symbols } = w['config'];
                w['config']['instruments'] = JSON.parse(
                    JSON.stringify(
                        instruments.filter(instrument => {
                            return symbols.indexOf(instrument.symbol) !== -1;
                        })
                    )
                );
            });

            const dispatcher = new ReactDispatcher(self);
            dispatcher.dispatch(widgets);
        });

        let gate = new WsGate(this.getOption('wsgate'), bus);
        gate.open().then(api => {
            api.subscribe(symbols);
        });

        return this;
    }

    get lang () {
        return lang;
    }

    /**
     * Returns application data bus
     * @return {object}
     */
    get bus () {
        return bus;
    }

    /**
     * Returns application meta information
     * @return {object}
     */
    get meta () {
        return meta;
    }

    /**
     * The application configuration option by name
     *
     * @param  {string} name
     * @param  {mixen} defaultValue
     * @return {mixen}
     */
    getOption (name, defaultValue = null) {
        appConfig[lang] = appConfig[lang] || {};
        return appConfig[lang][name] || appConfig[name] || defaultValue;
    }
}



// WEBPACK FOOTER //
// ./src/app.js